/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeLoginModalVisibility } from '../../DataStore/actions/modalWindowActions';
import LoginForm from './LoginForm/LoginForm';
import RegisterForm from './RegisterForm/RegisterForm';
import { ReactComponent as Close } from '../../images/close-r.svg';
import './css/LoginModal.css';

const mapStateToProps = (state) => ({ ...state });

class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRegisterForm: false,
      scrollbarWidth: 0,
    };
  }

  componentDidMount() {
    const scrollWidth =
      window.innerWidth - document.documentElement.clientWidth;
    this.setState({ scrollbarWidth: scrollWidth });
    document.addEventListener('keydown', this.handleEscPress, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscPress, false);
  }

  handleEscPress = (e) => {
    const { isLoginModalVisible } = this.props;

    if (isLoginModalVisible && e.key === 'Escape') {
      this.close();
    }
  };

  showRegisterForm = () => {
    this.setState({ isRegisterForm: true });
  };

  showLoginForm = () => {
    this.setState({ isRegisterForm: false });
  };

  handleOutCLick = (e) => {
    if (!this.node.contains(e.target)) {
      this.close();
    }
  };

  close = () => {
    const { changeLoginModalVisibility: changeLoginModalVisibilityAction } =
      this.props;

    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    this.setState({ isRegisterForm: false });

    changeLoginModalVisibilityAction(false);

    document.removeEventListener('click', this.handleOutsideClick, false);
  };

  render() {
    const { isLoginModalVisible, location } = this.props;
    const { isRegisterForm, scrollbarWidth } = this.state;

    if (!isLoginModalVisible) {
      return null;
    }

    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    return (
      <div>
        {isLoginModalVisible && (
          <div className="login_modal_w" onClick={this.handleOutCLick}>
            {/* <div className="login_modal_window"> */}
            <div
              className="login_modal_content"
              ref={(node) => {
                this.node = node;
              }}
            >
              <button
                type="button"
                onClick={this.close}
                className="login_madal_close"
              >
                <Close />
              </button>
              {isRegisterForm ? (
                <RegisterForm
                  closeModal={this.close}
                  location={location}
                  showLoginForm={this.showLoginForm}
                />
              ) : (
                <LoginForm
                  closeModal={this.close}
                  location={location}
                  showRegForm={this.showRegisterForm}
                />
              )}
            </div>
            {/* </div> */}
          </div>
        )}
      </div>
    );
  }
}

LoginModal.propTypes = {
  changeLoginModalVisibility: PropTypes.func.isRequired,
  isLoginModalVisible: PropTypes.bool.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default connect(mapStateToProps, { changeLoginModalVisibility })(
  LoginModal,
);
